/**
 * Source icon helper.
 *
 * Maps a `Source` (optionally refined by `source_type`) to a brand SVG from
 * `assets/result-thumbnails`. These assets are the single source of truth for
 * result icons - per-document thumbnail URLs are intentionally not used so the
 * visual language stays consistent across all sources.
 */

import copadataDocIcon from '../assets/result-thumbnails/copadata-doc.svg';
import dockerIcon from '../assets/result-thumbnails/Docker.svg';
import githubIcon from '../assets/result-thumbnails/GitHub.svg';
import websiteIcon from '../assets/result-thumbnails/Website.svg';
import youtubeIcon from '../assets/result-thumbnails/Youtube.svg';
import zohoDeskIcon from '../assets/result-thumbnails/Zoho desk.svg';
import academyIcon from '../assets/result-thumbnails/zenon Academy.svg';
import engineeringStoreIcon from '../assets/result-thumbnails/zenon engineering store.svg';
import portalKnowledgeIcon from '../assets/result-thumbnails/Portal- Knowledge.svg';
import portalForumIcon from '../assets/result-thumbnails/Portal-Forum.svg';
import portalTicketsIcon from '../assets/result-thumbnails/Portal-Tickets.svg';

const SOURCE_ICONS: Record<string, string> = {
  zenon_docs: copadataDocIcon,
  github: githubIcon,
  copadata_dockerhub: dockerIcon,
  copadata_youtube: youtubeIcon,
  zoho: zohoDeskIcon,
  cd_website: websiteIcon,
  multiterm: copadataDocIcon,
  sunrise: portalTicketsIcon,
  zenon_academy: academyIcon,
  engineering_store: engineeringStoreIcon,
  mock: websiteIcon,
};

// Zoho aggregates several portal areas that each have their own mark.
const SOURCE_TYPE_ICONS: Record<string, string> = {
  article: portalKnowledgeIcon,
  zoho_community: portalForumIcon,
  support_ticket: portalTicketsIcon,
  online_course: academyIcon,
  store_product: engineeringStoreIcon,
  video: youtubeIcon,
};

export function getSourceFallbackIcon(
  source: string | undefined,
  sourceType?: string,
): string {
  return (
    (sourceType ? SOURCE_TYPE_ICONS[sourceType] : undefined) ??
    (source ? SOURCE_ICONS[source] : undefined) ??
    websiteIcon
  );
}
